import { EntityName } from '@provision/entity-types/dist/entity.types';
import { EventHubEntityChangePayloadObject } from '@provision/event-hub-utils';
import { useEffect } from 'react';
import { constant } from 'remeda';
import { filter as filterFn } from 'rxjs/operators';
import { wsEventBus } from 'src/core/realtime-connection';

export const useOnDeleteSubscription = ({
  entityName,
  filter = constant(true),
  callback,
}: {
  entityName: EntityName;
  filter?: (message: EventHubEntityChangePayloadObject) => boolean;
  callback: (message: EventHubEntityChangePayloadObject) => void;
}) => {
  useEffect(() => {
    const deleteSubscription = wsEventBus
      .onEntity({
        name: entityName,
        operation: 'delete',
      })
      .pipe(filterFn(filter))
      .subscribe(callback);
    return () => {
      deleteSubscription.unsubscribe();
    };
  }, [callback, entityName, filter]);
};
